import React, { useEffect, useState, useRef } from "react";
import { classNames } from "../../helpers/classNames";

const Input = ({ label, labelClasses, inputType, inputClasses, inputPlaceholder, inputValue, inputName, errorType, errorText, isDisabled, value, required, iconClasses, maxLength, onChange = () => { }, onFocus = () => { }, onBlur = () => { }, onEnterClicked = () => { }, ...props }) => {
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const passwordInput = useRef(null);
  const handleClick = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  useEffect(() => {
    passwordInput.current.type = passwordVisibility ? "text" : inputType;
  }, [passwordVisibility]);

  return (
    <div className="w-full relative">
      {label && (
        <div className={"text-base font-medium text-md-dark mb-1 " + labelClasses}>
          {label}
          {required && (
            <span className="text-[8px] text-red-500 ml-1 absolute top-[-2px]">
              <i className="fa-solid fa-asterisk"></i>
            </span>
          )}
        </div>
      )}
      <div className="relative flex">
        {isDisabled ? (
          <input
            type={inputType}
            ref={passwordInput}
            className={"w-full py-0 h-12 rounded-md placeholder:text-md-dark bg-md-pink-light-2 border border-md-pink-light-1 px-3 text-md-dark text-base !ring-0 !outline-0 focus:border-md-pink/40 transition-all duration-200 " + inputClasses}
            placeholder={inputPlaceholder}
            name={inputName}
            defaultValue={inputValue}
            autoComplete={"new-" + inputType}
            value={value}
            disabled
          />
        ) : (
          <input
            type={inputType}
            ref={passwordInput}
            className={"w-full py-0 h-12 rounded-md placeholder:text-md-dark bg-md-pink-light-2 border border-md-pink-light-1 px-3 text-md-dark text-base !ring-0 !outline-0 focus:border-md-pink/40 transition-all duration-200 " + inputClasses}
            value={value}
            maxLength={maxLength}
            placeholder={inputPlaceholder}
            name={inputName}
            defaultValue={inputValue}
            autoComplete={"new-" + inputType}
            onChange={(e) => onChange(e)}
            onFocus={(e) => onFocus(e)}
            onBlur={(e) => onBlur(e)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                onEnterClicked();
              }
            }}
          />
        )}
        {inputType === "password" && (
          <button type="button" className={classNames("h-full aspect-square absolute top-0 right-0 bg-transparent text-slate-500", iconClasses)} onClick={handleClick}>
            <i className={"fa-regular fa-fw " + (passwordVisibility ? "fa-eye-slash" : "fa-eye")}></i>
          </button>
        )}
      </div>
      {errorType && errorType === "error" && (
        <div className="text-xs text-red-600 mt-1">
          <i className="fa-regular fa-fw fa-square-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "warning" && (
        <div className="text-xs text-amber-600 mt-1">
          <i className="fa-regular fa-fw fa-triangle-exclamation text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "success" && (
        <div className="text-xs text-green-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-check text-sm mr-1"></i>
          {errorText}
        </div>
      )}
      {errorType && errorType === "info" && (
        <div className="text-xs text-sky-600 mt-1">
          <i className="fa-regular fa-fw fa-circle-info text-sm mr-1"></i>
          {errorText}
        </div>
      )}
    </div>
  );
};

export default Input;
